const defaultState = {
  email: '',
  isLoading: false,
  isError: false,
  isSuccess: false,
  error: '',
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'AUTH_WELCOME_SET_PASSWORD_INIT': {
      return {
        ...state,
        email: '',
        isLoading: false,
        isError: false,
        isSuccess: false,
        error: '',
      };
    }
    case 'AUTH_WELCOME_SET_PASSWORD_PENDING': {
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: '',
      };
    }
    case 'AUTH_WELCOME_SET_PASSWORD_SUCCESS': {
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        isError: false,
        error: '',
      };
    }
    case 'AUTH_WELCOME_SET_PASSWORD_ERROR': {
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        error:
          action && action.err && action.err.message ? action.err.message : '',
      };
    }
    default:
      return state;
  }
};
